import useGetRuleColumns from 'Hooks/useGetRuleColumns';

const useGetTenantGroupOverrideRulesColumns = () => {
    const columns = useGetRuleColumns({
        columns: [
            'modifiedFlag',
            {
                Header: () => null,
                id: 'ruleGroup',
                disableSortBy: true,
                accessor: (d) => {
                    return `${d?.ruleGroup}`;
                }
            },
            'ruleId',
            {
                Header: 'Rule Description',
                id: '_formatted.inputDescription',
                dataType: 'text',
                width: 160,
                accessor: (d) => d?._formatted?.inputDescription
            },
            {
                id: '_formatted.outputDescription',
                Header: 'Conclusion',
                renderType: 'conclusion',
                dataType: 'conclusion',
                width: 80,
                renderOptions: (d) => {
                    return {
                        score: d?.parameters.score
                    };
                },
                preformattedValue: (d) => d?.parameters.score || d?.outputDescription,
                accessor: (d) => d?._formatted?.outputDescription
            },
            {
                id: 'ruleType',
                Header: 'Rule Type',
                dataType: 'text',
                width: 80,
                accessor: 'ruleType',
                renderType: 'ruleType'
            },
            'lastModified',
            'status'
        ]
    });
    return columns;
};

export default useGetTenantGroupOverrideRulesColumns;
